module.exports = __webpack_public_path__ + "img/huawuIcon4.c4f7754d.png";